export type TeamMember = {
  id: string;
  name: string;
  role: string;
  phone: string;
  email: string;
};

export const TEAM_MEMBERS_STORAGE_KEY = "ns_team_members";

export function loadTeamMembers(): TeamMember[] {
  try {
    const raw = localStorage.getItem(TEAM_MEMBERS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (m): m is TeamMember =>
        m &&
        typeof m === "object" &&
        typeof m.id === "string" &&
        typeof m.name === "string"
    );
  } catch {
    return [];
  }
}

export function saveTeamMembers(members: TeamMember[]): void {
  localStorage.setItem(TEAM_MEMBERS_STORAGE_KEY, JSON.stringify(members));
}

export function memberInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
